import { TFunction } from 'i18next'
import { StringSchema, string } from 'yup'

import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const stringSchema = (
  t: TFunction<'translation', undefined>,
  charLimit = 255,
): StringSchema<string | undefined> =>
  string()
    .defined()
    .typeError(t(formTranslation.errors.fieldRequired))
    .test(
      'len',
      t(formTranslation.errors.maxChars, { value: charLimit }),
      val => val?.length <= charLimit,
    )
